var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#FFC107"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0483 111L30.3438 41.1818H43.946L56.5256 92.4886H57.1733L70.6051 41.1818H82.9801L96.446 92.5227H97.0597L109.639 41.1818H123.241L103.537 111H91.0597L77.0824 62.0114H76.5369L62.5256 111H50.0483ZM134.415 111H120.915L145.494 41.1818H161.108L185.722 111H172.222L153.574 55.5H153.028L134.415 111ZM134.858 83.625H171.676V93.7841H134.858V83.625ZM196.29 41.1818L214.46 96.1364H215.176L233.312 41.1818H247.222L222.608 111H206.994L182.415 41.1818H196.29Z",
    fill: "#FAFAFD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_680)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M309.833 352.773C315.408 351.796 320.677 351.959 325.295 353.037V244.496L210.447 277.476V403.513C210.508 404.205 210.549 404.917 210.549 405.609V405.629C210.549 422.597 192.747 439.443 170.775 443.247C148.822 447.031 131 436.35 131 419.362C131 402.394 148.822 385.549 170.775 381.764C179.035 380.34 186.725 380.971 193.093 383.209V228.058H194.049L342.67 194V368.805C342.934 370.086 343.077 371.389 343.077 372.691C343.077 372.691 343.077 372.691 343.077 372.711C343.077 386.891 328.184 400.97 309.853 404.124C291.502 407.298 276.63 398.366 276.63 384.186C276.61 370.005 291.482 355.926 309.833 352.773Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_680",
    x: 18.3438,
    y: 41.1836,
    width: 232.879,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_680",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212.056,
    height: 250,
    fill: "white",
    transform: "translate(131 194)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWav);
export default __webpack_public_path__ + "static/media/wav.afda72b49d7c36d21b258d0f64170500.svg";
export { ForwardRef as ReactComponent };